const programs = [
	{ "name": "ISV Accelerate", "category": "Compensation" },
	{ "name": "SaaS Revenue Recognition", "category": "Compensation" },
	{ "name": "Co-Sell Incentivized", "category": "Compensation" },
	{ "name": "Co-Sell Prioritized", "category": "Compensation" },
	{ "name": "MACC", "category": "Compensation" },
	{ "name": "CPPO", "category": "Compensation" },
	{ "name": "MPPOP", "category": "Compensation" },
	{ "name": "PR ACR", "category": "Compensation" },
	{ "name": "Top Tier", "category": "Compensation" },
	{ "name": "Competency", "category": "Differentiation" },
	{ "name": "AWS Service Ready Program", "category": "Differentiation" },
	{ "name": "Industry Cloud", "category": "Differentiation" },
	{ "name": "Product Integration", "category": "Integration" },
	{ "name": "Digital Innovation", "category": "Promotion" },
	{ "name": "Workload Migration", "category": "Promotion" },
	{ "name": "Fast Track", "category": "Promotion" },
	{ "name": "Well-Architected Framework", "category": "Promotion" },
	{ "name": "Migration Acceleration", "category": "Promotion" },
	{ "name": "ISV Success Program", "category": "Promotion" },
	{ "name": "Microsoft AI Partner Council program", "category": "Promotion" },
	{ "name": "Global Startup", "category": "Promotion" },
	{ "name": "Marketplace", "category": "Tier" },
	{ "name": "FTR Validation", "category": "Tier" },
	{ "name": "Enrolled", "category": "Tier" },
	{ "name": "Confirmed", "category": "Tier" },
	{ "name": "Validated", "category": "Tier" },
	{ "name": "Differentiated", "category": "Tier" }
];

const getProgramCategory = program => { return programs.find(p => p.name === program.Program__c).category };

export const appendProgramsCategories = programs => {
	programs.forEach(p => {
		p.category = getProgramCategory(p);
	});

	return programs;
};

